(function() {
    angular
        .module('emarket.commons')
        .controller('CustomFieldDialogController', ['$log', '$scope', '$rootScope', '$mdDialog', 'field', function($log,
            $scope,
            $rootScope,
            $mdDialog,
            field) {
            var vm = this;
            vm.field = field;
            $log.info(field);
            if (vm.field.showAs === 'range') {
                vm.field.values = [];

                for (
                    var i = vm.field.validation.max;
                    i >= vm.field.validation.min;
                    i--
                ) {
                    vm.field.values.push(i.toString());
                }
            }
            vm.close = function() {
                $mdDialog.cancel();
            };
            vm.chooseOption = function(option) {
                $mdDialog.hide(option);
            };
            vm.chooseDefaultOption = function(field) {
                var option = null;
                if (field.dataType === 'number') {
                    option = '+3';
                }
                vm.chooseOption(option);
            };
            var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess',
                function() {
                    vm.close();
                });
            var locationChangeSuccessEvent = $rootScope.$on('$locationChangeSuccess',
                function() {
                    vm.close();
                });
            vm.refresh = true;
            $scope.$on('$destroy', function() {
                stateChangeSuccessEvent();
                locationChangeSuccessEvent();
            });
        }]);
}());
